const userSessionKey = 'userSessionInfo';

const getUserSession = () => {
  const sessionAsString = localStorage.getItem(userSessionKey);

  if (!sessionAsString) {
    return;
  }
  const parsedSession = JSON.parse(sessionAsString);

  if (!parsedSession) {
    return;
  }

  const timeDiff = getCurrentEpoch() - parsedSession.timeStamp;

  if (timeDiff < 0) {
    return;
  }

  return parsedSession;
};

const setUserSession = (connectionInfo) => {
  if (!connectionInfo) {
    return;
  }
  const { _id, _rev, accessToken, instanceUrl } = connectionInfo;
  const destructured = { _id, _rev, accessToken, instanceUrl };
  console.log('passed');
  const epochTimeStamp = getCurrentEpoch();
  destructured.timeStamp = epochTimeStamp + 7200 * 1000; //add 2 hours which is approx the timeout for the SF sesssion
  localStorage.setItem(userSessionKey, JSON.stringify(destructured));
};

export { getUserSession, setUserSession };

function getCurrentEpoch() {
  return Math.floor(Date.now());
}
